import { HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MatSelectChange, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { ICalendar } from 'src/app/interfaces/calendar';
import { IConfirm } from 'src/app/interfaces/confirm';
import { IError } from 'src/app/interfaces/error.interface';
import { IParentTerm } from 'src/app/interfaces/parent-term';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { ParrentTermService } from 'src/app/services/http/business/parrent-term/parrent-term-service.service';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { TimesheetService } from 'src/app/services/http/business/timesheet/timesheet-service.service';

@Component({
  selector: 'app-timesheet-management',
  templateUrl: './timesheet-management.component.html',
  styleUrls: ['./timesheet-management.component.css']
})
export class TimesheetManagementComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();
  WeekDays = [];
  eduPackageList: any;
  form: FormGroup;
  weekdayForm: FormGroup;
  yearList: ICalendar;
  parrentTermList: IParentTerm[];
  timeSheet: any;
  timeList: any;
  companyList: any;
  branchList: any;

  cidSelected: any;
  bidSelected: any;
  allBranchChecked: boolean = false;

  constructor(
    private fb: FormBuilder,
    private calendarService: CalendarService,
    private parrentTermService: ParrentTermService,
    private timesheetService: TimesheetService,
    private eduPackageService: EducationPackageService,
    public translate: TranslateService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private snackBar: SnackBarService,
    private dialog: MatDialog,
    private staticValueService: StaticValueService,
    private errorService: ErrorsService,
    public dialogRef: MatDialogRef<TimesheetManagementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
    this.loadYear();
    this.getParrentTermList();
    this.getWeekDays(false);
    this.getEduPackage();
    this.getCompanyList();
  }

  createForm() {
    this.form = this.fb.group({
      ParentTermId: [null, Validators.required],
      Year: [null, Validators.required],
      weekDays: this.fb.array([]),
      TimeSheetPackageList: [],
      HasPrivateCourse: [null],
      HasMarketingCourse: [null]
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });

  }

  getBranchList(company) {
    this.cidSelected = company;

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });


    // this.branchService.listByLogin(0, 0).subscribe(res => {
    //   this.branchList = res.DataList;
    // });
  }

  showAllBranch() {
    this.allBranchChecked = !this.allBranchChecked;
  }

  setBid(bid: string) {
    this.bidSelected = bid;
    this.data.cid = this.cidSelected;
    this.data.bid = bid;
    this.createForm();
    this.loadYear();
    this.getParrentTermList();
    this.getWeekDays(false);
    this.getEduPackage();
  }

  getPackageName(packageId: number) {
    return this.eduPackageList.filter(function (e) {
      return e.Id == packageId;
    })[0].Description
  }
  createFormWeekDays(items: any): void {

    const creds = this.form.controls.weekDays as FormArray;
    items.forEach((element) => {
      creds.push(
        this.fb.group({
          WeekDayId: new FormControl(element["Value"]),
          isActive: new FormControl(element.Selected),
          WeekDayName: new FormControl(element.Text),
          a: new FormControl(null),
          b: new FormControl(null),
          c: new FormControl(null),
          d: new FormControl(null),
          e: new FormControl(null),
          f: new FormControl(null),
          g: new FormControl(null),
          h: new FormControl(null)
        })
      );
    });
  }


  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getEduPackage() {
    this.eduPackageService.getListByMaster(this.data.nationalCode).subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getWeekDays(value: boolean) {
    this.staticValueService.getWeekDays(value).subscribe(
      res => {
        this.WeekDays = res;
        this.createFormWeekDays(this.WeekDays);
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getParrentTermList() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.data.cid
      );
    this.parrentTermService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.parrentTermList = res.DataList;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      }
    );
  }

  loadTimeSheets(event: MatSelectChange) {
    const query = {
      BranchEncryptId: this.data.bid,
      ParentTermId: event.value,
      NationalCode: this.data.nationalCode,
      Year: this.form.controls["Year"].value,
      TimeSheetPackageList: []
    }

    const headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.data.cid
      );

    this.timesheetService.getTimeSheet(query, headers).subscribe(res => {
      this.timeSheet = res;
      // if (res && res.TimeSheetList.length <= 0)

    },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      })
  }

  setTime(weekDay: FormGroup, num: number) {
    switch (num) {
      case 1:
        if (weekDay.controls['a'].value)
          weekDay.controls['a'].patchValue(false);
        else
          weekDay.controls['a'].patchValue(true);
        break;

      case 2:
        if (weekDay.controls['b'].value)
          weekDay.controls['b'].patchValue(false);
        else
          weekDay.controls['b'].patchValue(true);
        break;

      case 3:
        if (weekDay.controls['c'].value)
          weekDay.controls['c'].patchValue(false);
        else
          weekDay.controls['c'].patchValue(true);
        break;

      case 4:
        if (weekDay.controls['d'].value)
          weekDay.controls['d'].patchValue(false);
        else
          weekDay.controls['d'].patchValue(true);
        break;

      case 5:
        if (weekDay.controls['e'].value)
          weekDay.controls['e'].patchValue(false);
        else
          weekDay.controls['e'].patchValue(true);
        break;

      case 6:
        if (weekDay.controls['f'].value)
          weekDay.controls['f'].patchValue(false);
        else
          weekDay.controls['f'].patchValue(true);
        break;

      case 7:
        if (weekDay.controls['g'].value)
          weekDay.controls['g'].patchValue(false);
        else
          weekDay.controls['g'].patchValue(true);
        break;

      case 8:
        if (weekDay.controls['h'].value)
          weekDay.controls['h'].patchValue(false);
        else
          weekDay.controls['h'].patchValue(true);
        break;
    }
  }


  submit(form: any) {

    const confirm: IConfirm = {
      accept: true,
      message: "کاربر گرامی دقت نمایید در صورت ذخیره تایم شیت امکان تغییر مقدور نمیباشد. لطفا از صحت مقادیر وارد شده اطمینان حاصل نمایید.",
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "700px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.errors = new Array();
          if (form.TimeSheetPackageList) {
            const command: any = {
              "BranchEncryptId": this.data.bid,
              "NationalCode": this.data.nationalCode,
              "ParentTermId": form.ParentTermId,
              "Year": parseInt(form.Year),
              "HasPrivateCourse": form.HasPrivateCourse,
              "HasMarketingCourse": form.HasMarketingCourse,
              "TimeSheetList": [],
              "TimeSheetPackageList": form.TimeSheetPackageList.map(function (e) {
                return { PackageId: e };
              })
            }
            form.weekDays.forEach(x => {
              debugger
              if (x.isActive) {
                if (x.a)
                  command.TimeSheetList.push({
                    WeekDayId: x.WeekDayId,
                    TimeStart: '08:00',
                    TimeEnd: '09:30'
                  });
                if (x.b)
                  command.TimeSheetList.push({
                    WeekDayId: x.WeekDayId,
                    TimeStart: '09:45',
                    TimeEnd: '11:15'
                  });
                if (x.c)
                  command.TimeSheetList.push({
                    WeekDayId: x.WeekDayId,
                    TimeStart: '11:30',
                    TimeEnd: '13:00'
                  });
                if (x.d)
                  command.TimeSheetList.push({
                    WeekDayId: x.WeekDayId,
                    TimeStart: '13:15',
                    TimeEnd: '14:45'
                  });
                if (x.e)
                  command.TimeSheetList.push({
                    WeekDayId: x.WeekDayId,
                    TimeStart: '15:00',
                    TimeEnd: '16:30'
                  });
                if (x.f)
                  command.TimeSheetList.push({
                    WeekDayId: x.WeekDayId,
                    TimeStart: '16:45',
                    TimeEnd: '18:15'
                  });
                if (x.g)
                  command.TimeSheetList.push({
                    WeekDayId: x.WeekDayId,
                    TimeStart: '18:30',
                    TimeEnd: '20:00'
                  });
                if (x.h)
                  command.TimeSheetList.push({
                    WeekDayId: x.WeekDayId,
                    TimeStart: '20:15',
                    TimeEnd: '21:45'
                  });
              }
            });
            if (command && command.BranchEncryptId) {
              if (!command.TimeSheetList || !command.TimeSheetPackageList) {
                this.snackBar.OpenSnackBar(
                  "لطفا اطلاعات مربوط به پکیج ها و بازه های زمانی به درستی انتخاب شوند.",
                  "ok",
                  5000,
                  SoundEnum.beep
                );
              }
              else
                this.timesheetService.save(command).subscribe(() => {

                  this.snackBar.OpenSnackBar(
                    "تایم شیت با موفقیت ذخیره گردید.",
                    "ok",
                    5000,
                    SoundEnum.beep
                  );

                  // this.form.controls['weekDays'] = this.fb.array([]);
                  // this.form.controls['TimeSheetPackageList'].patchValue(null);
                  // this.getWeekDays(false);

                  this.timeSheet = null;
                  const query = {
                    BranchEncryptId: this.data.bid,
                    ParentTermId: command.ParentTermId,
                    Year: command.Year,
                    TimeSheetPackageList: []
                  }
                  const headers = new HttpHeaders({
                    "Content-Type": "application/json"
                  })
                    .append("Authorization", "Bearer " + localStorage.getItem("token"))
                    .append(
                      "HID",
                      localStorage.getItem("holdingCode")
                        ? localStorage.getItem("holdingCode")
                        : ""
                    )
                    .append(
                      "CID",
                      this.data.cid
                    );

                  this.timesheetService.getTimeSheet(query, headers).subscribe(res => {
                    this.timeSheet = res;
                  },
                    err => {
                      // this.errObject = this.errorService.getError(err);
                      // this.param = this.errorService.objectError(this.errObject);
                      // this.errors = this.errorService.returnError(err);
                      this.errorList = this.errorService.getErrorList(err.error)
                    })

                }, err => {
                  // this.errObject = this.errorService.getError(err);
                  // this.param = this.errorService.objectError(this.errObject);
                  // this.errors = this.errorService.returnError(err);
                  this.errorList = this.errorService.getErrorList(err.error)
                })
            }
          }
          else {
            this.snackBar.OpenSnackBar(
              "لطفا اطلاعات مربوط به پکیج ها و بازه های زمانی به درستی انتخاب شوند.",
              "ok",
              5000,
              SoundEnum.beep
            );
          }

        }
      });


  }

}
